import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import Switch from "Common/Custom/Switch";
import FormSelect from "Common/Custom/FormSelect";

const EditPaymentSetupForm = ({
  values,
  errors,
  handleChange,
  handleSubmit,
  loading,
  title = "Update Payment Setup",
  fields,
  PaymentMethodOptions = [],
  CurrencyOptions = []
}) => {
  return (
    <PageBody
      headerchildren={<HeadingOne>{title}</HeadingOne>}
      onSubmit={handleSubmit}
    >

      {fields.map((field) => {

        if (field.type === "select") {
          let options = [];
          if (field.name === "payment_method_id") {
            options = PaymentMethodOptions?.map((opt) => ({
              value: opt.payment_method_id,
              label: opt.payment_method_name
            })) || [];
          }

          if (field.name === "currency_id") {
            options = CurrencyOptions?.map((opt) => ({
              value: opt.currency_id,
              label: opt.currency_name
            })) || [];
          }

          if (field.name === "environment") {
            options = field.options || [];
          }

          return (
            <FormSelect
              key={field.name}
              field={field}
              value={values[field.name]}
              handleChange={handleChange}
              options={options}
              error={errors[field.name]}
            />
          );
        }


        if (field.type === "switch") {
          return (
            <Switch
              key={field.name}
              values={values[field.name]}
              handleChange={handleChange}
              field={field}
              ValueOne="1"
              ValueTwo="0"
              LabelOne="Active"
              LabelTwo="Inactive"
            />
          );
        }

        return (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
      })}

      <FormSubmitButton
        label={` ${title}`}
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

export default EditPaymentSetupForm;
